import { useCallback } from "react";
import type { CashierTradingAccountMargin } from "@/api/cashier";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  setSelectedTransferAccount,
  setSelectedTransferToAccount,
} from "@/redux/slices/accountSlice";

export const useAccount = () => {
  const dispatch = useAppDispatch();
  const selectedAccount = useAppSelector(
    (state) => state.account.transfer.selectedAccount
  );
  const selectedToAccount = useAppSelector(
    (state) => state.account.transfer.selectedToAccount
  );
  return {
    setSelectedAccount: useCallback(
      (account: CashierTradingAccountMargin) => {
        dispatch(setSelectedTransferAccount(account));
      },
      [dispatch]
    ),
    isSelectedAccount: useCallback(
      (accountNumber: string | number) => {
        return selectedAccount?.accountId === accountNumber;
      },
      [selectedAccount]
    ),
    selectedAccount,
    setSelectedToAccount: useCallback(
      (account: CashierTradingAccountMargin | null) => {
        dispatch(setSelectedTransferToAccount(account));
      },
      [dispatch]
    ),
    isSelectedToAccount: useCallback(
      (accountNumber: string | number) => {
        return selectedToAccount?.accountId === accountNumber;
      },
      [selectedToAccount]
    ),
    selectedToAccount,
  };
};
